import AgeChecker from './AgeChecker';

export default AgeChecker;
